import CapacitacionesTPContent from "../components/FormacionDesarrollo/Capacitaciones/CapacitacionesTPContent";
import TrainingPlansState from "../context/FormacionDesarollo/TrainingPlansState";

const CapacitacionesTPScreen = () => {
  return (
    <TrainingPlansState>
      <CapacitacionesTPContent></CapacitacionesTPContent>
    </TrainingPlansState>
  );
};
export default CapacitacionesTPScreen;
